@if (!isPublicPage) {
  <button class="tt-sticky-header_back-button" ttButton variant="'transparent'" (click)="navigateBack()">
    <mat-icon [icon]="'chevron-left'" [iconSize]="16" />
    {{ 'Back' | transloco }}
  </button>
}

@if (showContentChangedBanner()) {
  <tt-banner
    class="tt-sticky-header_banner"
    [message]="'GuidelineReview.ContentOfReviewedGuidelineIsEdited' | transloco"
    [type]="'error'" />
}

@if (showContentEditingBanner()) {
  <tt-banner
    class="tt-sticky-header_banner"
    [message]="'GuidelineReview.ContentOfReviewedGuidelineIsEditing' | transloco"
    [type]="'warning'" />
}

<div class="tt-sticky-header_info">
  <div class="tt-sticky-header_title">
    {{ title }}
  </div>
  @if (organisationImage) {
    <img alt="{{ 'OrganizationImage' | transloco }}" class="tt-sticky-header_image" [src]="organisationImage" />
  }
</div>
